import React from "react";
import { FaUserCircle } from "react-icons/fa";

export const Avatar = () => {
    return <FaUserCircle size={"2.5rem"} color="#D3D7E1" />;
};
